const PLACEHOLDER_DATE_PATTERNS = [
  "check website",
  "check link",
  "check dates",
  "date tbc",
  "tbc",
  "flexible dates",
  "multiple start dates",
  "enquire below",
];

export function isPlaceholderBatchDate(value) {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return true;
  return PLACEHOLDER_DATE_PATTERNS.some((pattern) => text.includes(pattern));
}

function pickPositiveNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : null;
}

/** Resolve shared/private discounts as INR bases (source of truth). */
export function getBatchPricesInr(batch) {
  const shared =
    pickPositiveNumber(batch?.price_shared_discount_inr) ||
    pickPositiveNumber(batch?.price_2_sharing_discount) ||
    null;
  const privateAmt =
    pickPositiveNumber(batch?.price_private_discount_inr) ||
    pickPositiveNumber(batch?.price_private_discount) ||
    null;
  return { sharedInr: shared, privateInr: privateAmt };
}

/**
 * @param {object} batch
 * @param {string} currency - visitor currency (unused for storage; kept for call compat)
 * @param {(amountInr: number|null, currency: string) => string|null} formatPrice
 *        Formats an INR amount into display currency string.
 */
export function getBatchPrices(batch, currency, formatPrice) {
  const { sharedInr, privateInr } = getBatchPricesInr(batch);
  return {
    sharedPrice: sharedInr != null ? formatPrice(sharedInr, currency) : null,
    privatePrice: privateInr != null ? formatPrice(privateInr, currency) : null,
  };
}

export function batchHasDisplayableDateAndPrice(batch, currency, formatPrice) {
  const dateLabel = (batch?.course_date || "").toString().trim();
  if (isPlaceholderBatchDate(dateLabel)) return false;

  const { sharedPrice, privatePrice } = getBatchPrices(batch, currency, formatPrice);
  return Boolean(sharedPrice || privatePrice);
}

export function getDisplayableBatches(batches, currency, formatPrice) {
  if (!Array.isArray(batches) || batches.length === 0) return [];
  return batches.filter((batch) => batchHasDisplayableDateAndPrice(batch, currency, formatPrice));
}
